export default "__VITE_ASSET__acb1c638__"